"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var Form = formik_1.Form;
exports.default = Form;
//# sourceMappingURL=index.js.map